export default {"src":"/_next/static/media/decrypt.6e8a870f.svg","height":686,"width":811};